/* Al Fagr - collection filters (client side, all pages loaded in background) */
(function () {
  'use strict';
  var D = document;
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };
  var ar = (D.documentElement.lang || '').slice(0, 2) === 'ar';
  var T = function (en, a) { return ar ? a : en; };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var ORDER = ['xxs', 'xs', 's', 'm', 'l', 'xl', '2xl', 'xxl', '3xl', 'xxxl', '4xl', '5xl'];

  function init(root) {
    if (root.__cc) return; root.__cc = 1;
    var grid = $('[data-cc-grid]', root), side = $('[data-cc-side]', root);
    var facets = $('[data-cc-facets]', root), chips = $('[data-cc-chips]', root);
    var S = { avail: false, sale: false, min: null, max: null, sz: {}, cl: {}, t: {} };
    var bounds = [0, 0], hexMap = {};

    function items() { return $$('.fg-cc__it', grid); }
    function split(v) { return (v || '').split('|').filter(Boolean); }
    function count(o) { return Object.keys(o).length; }

    function colourHex(it, name) {
      if (hexMap[name]) return hexMap[name];
      var d = $('[data-fg-sw="' + name.replace(/"/g, '\\"') + '"]', it);
      if (d) { var bg = getComputedStyle(d).backgroundColor; if (bg && bg !== 'rgba(0, 0, 0, 0)') hexMap[name] = bg; }
      return hexMap[name] || '#cfc6bb';
    }
    function tally() {
      var sz = {}, cl = {}, ty = {}, mn = Infinity, mx = 0, colIt = {};
      items().forEach(function (it) {
        split(it.dataset.sz).forEach(function (s) { sz[s] = (sz[s] || 0) + 1; });
        split(it.dataset.cl).forEach(function (c) { cl[c] = (cl[c] || 0) + 1; if (!colIt[c]) colIt[c] = it; });
        var t = it.dataset.t; if (t) ty[t] = (ty[t] || 0) + 1;
        var p = +it.dataset.p; if (p < mn) mn = p; if (p > mx) mx = p;
      });
      return { sz: sz, cl: cl, ty: ty, mn: mn === Infinity ? 0 : Math.floor(mn), mx: Math.ceil(mx), colIt: colIt };
    }
    function sizeKeys(sz) {
      return Object.keys(sz).sort(function (a, b) {
        var na = parseFloat(a), nb = parseFloat(b);
        if (!isNaN(na) && !isNaN(nb)) return na - nb;
        var ia = ORDER.indexOf(a.toLowerCase()), ib = ORDER.indexOf(b.toLowerCase());
        if (ia > -1 && ib > -1) return ia - ib;
        return a.localeCompare(b);
      });
    }
    function group(title, body, open) {
      return '<div class="fg-cc__g' + (open ? ' is-open' : '') + '"><button type="button" class="fg-cc__gh" data-cc-g>' + title + '</button><div class="fg-cc__gb">' + body + '</div></div>';
    }
    function build() {
      var t = tally(); bounds = [t.mn, t.mx];
      var h = '';
      h += group(T('Availability', 'التوفر'), '<label class="fg-cc__tg"><input type="checkbox" data-cc-avail' + (S.avail ? ' checked' : '') + '><span>' + T('In stock only', 'المتاح فقط') + '</span></label><label class="fg-cc__tg"><input type="checkbox" data-cc-sale' + (S.sale ? ' checked' : '') + '><span>' + T('On sale', 'عليه خصم') + '</span></label>', true);
      if (t.mx > t.mn) {
        var lo = S.min == null ? t.mn : S.min, hi = S.max == null ? t.mx : S.max;
        h += group(T('Price', 'السعر'), '<div class="fg-cc__pr"><input type="number" data-cc-min value="' + lo + '" min="' + t.mn + '" max="' + t.mx + '" aria-label="min"><i>–</i><input type="number" data-cc-max value="' + hi + '" min="' + t.mn + '" max="' + t.mx + '" aria-label="max"></div><input type="range" class="fg-cc__rng" data-cc-rng min="' + t.mn + '" max="' + t.mx + '" value="' + hi + '"><div class="fg-cc__qp"><button type="button" data-cc-qp="0-' + Math.round(t.mx * .4) + '">' + T('Budget', 'اقتصادي') + '</button><button type="button" data-cc-qp="' + Math.round(t.mx * .4) + '-' + Math.round(t.mx * .75) + '">' + T('Mid', 'متوسط') + '</button><button type="button" data-cc-qp="' + Math.round(t.mx * .75) + '-' + t.mx + '">' + T('Premium', 'بريميم') + '</button></div>', true);
      }
      var sk = sizeKeys(t.sz);
      if (sk.length) h += group(T('Size', 'المقاس'), '<div class="fg-cc__chipsz">' + sk.map(function (s) { return '<button type="button" class="fg-cc__sz' + (S.sz[s] ? ' is-on' : '') + '" data-cc-sz="' + esc(s) + '">' + esc(s) + '</button>'; }).join('') + '</div>', true);
      var ck = Object.keys(t.cl).sort();
      if (ck.length) h += group(T('Colour', 'اللون'), '<div class="fg-cc__cols2">' + ck.map(function (c) { return '<button type="button" class="fg-cc__cl' + (S.cl[c] ? ' is-on' : '') + '" data-cc-cl="' + esc(c) + '"><i style="background:' + colourHex(t.colIt[c], c) + '"></i>' + esc(c) + ' <em>' + t.cl[c] + '</em></button>'; }).join('') + '</div>', true);
      var tk = Object.keys(t.ty).sort();
      if (tk.length > 1) h += group(T('Type', 'النوع'), tk.map(function (x) { return '<label class="fg-cc__tg"><input type="checkbox" data-cc-t="' + esc(x) + '"' + (S.t[x] ? ' checked' : '') + '><span>' + esc(x) + ' <em>' + t.ty[x] + '</em></span></label>'; }).join(''), false);
      var open = $$('.fg-cc__g', facets).map(function (g) { return g.classList.contains('is-open'); });
      facets.innerHTML = h;
      if (open.length) $$('.fg-cc__g', facets).forEach(function (g, i) { if (open[i] != null) g.classList.toggle('is-open', open[i]); });
    }
    function pass(it) {
      var d = it.dataset, p = +d.p;
      if (S.avail && d.a !== '1') return false;
      if (S.sale && d.sale !== '1') return false;
      if (S.min != null && p < S.min) return false;
      if (S.max != null && p > S.max) return false;
      var k;
      if (count(S.sz)) { var a = split(d.sz); if (!a.some(function (x) { return S.sz[x]; })) return false; }
      if (count(S.cl)) { var b = split(d.cl); if (!b.some(function (x) { return S.cl[x]; })) return false; }
      if (count(S.t) && !S.t[d.t]) return false;
      return true;
    }
    function activeList() {
      var l = [];
      if (S.avail) l.push(['avail', '', T('In stock', 'متاح')]);
      if (S.sale) l.push(['sale', '', T('On sale', 'عليه خصم')]);
      if (S.min != null || S.max != null) l.push(['price', '', (S.min != null ? S.min : bounds[0]) + ' – ' + (S.max != null ? S.max : bounds[1])]);
      Object.keys(S.sz).forEach(function (k) { l.push(['sz', k, T('Size ', 'مقاس ') + k]); });
      Object.keys(S.cl).forEach(function (k) { l.push(['cl', k, k]); });
      Object.keys(S.t).forEach(function (k) { l.push(['t', k, k]); });
      return l;
    }
    function apply() {
      var n = 0;
      items().forEach(function (it) { var ok = pass(it); it.hidden = !ok; if (ok) n++; });
      $('[data-cc-count]', root).textContent = n;
      $('[data-cc-empty]', root).hidden = n > 0;
      var l = activeList();
      chips.innerHTML = l.length ? l.map(function (a) { return '<button type="button" class="fg-cc__chip" data-cc-rm="' + a[0] + '" data-v="' + esc(a[1]) + '">' + esc(a[2]) + ' ×</button>'; }).join('') + '<button type="button" class="fg-cc__chip fg-cc__chip--c" data-cc-clear>' + T('Clear all', 'مسح الكل') + '</button>' : '';
      var bd = $('[data-cc-badge]', root); bd.hidden = !l.length; bd.textContent = l.length;
    }
    function refresh(rebuild) { if (rebuild) build(); apply(); }
    function toggle(o, k) { if (o[k]) delete o[k]; else o[k] = 1; }

    root.addEventListener('click', function (e) {
      var x;
      if ((x = e.target.closest('[data-cc-g]'))) { x.parentNode.classList.toggle('is-open'); return; }
      if ((x = e.target.closest('[data-cc-sz]'))) { toggle(S.sz, x.dataset.ccSz); refresh(true); return; }
      if ((x = e.target.closest('[data-cc-cl]'))) { toggle(S.cl, x.dataset.ccCl); refresh(true); return; }
      if ((x = e.target.closest('[data-cc-qp]'))) { var r = x.dataset.ccQp.split('-'); S.min = +r[0]; S.max = +r[1]; refresh(true); return; }
      if (e.target.closest('[data-cc-clear]')) { S = { avail: false, sale: false, min: null, max: null, sz: {}, cl: {}, t: {} }; refresh(true); return; }
      if ((x = e.target.closest('[data-cc-rm]'))) {
        var k = x.dataset.ccRm, v = x.dataset.v;
        if (k === 'avail') S.avail = false; else if (k === 'sale') S.sale = false; else if (k === 'price') { S.min = null; S.max = null; } else delete S[k][v];
        refresh(true); return;
      }
      if (e.target.closest('[data-cc-open]')) { root.classList.add('is-fopen'); D.documentElement.classList.add('fg-cc-lock'); return; }
      if (e.target.closest('[data-cc-close]')) { root.classList.remove('is-fopen'); D.documentElement.classList.remove('fg-cc-lock'); return; }
      if ((x = e.target.closest('[data-cc-cols]'))) { grid.style.setProperty('--cols', x.dataset.ccCols); $$('[data-cc-cols]', root).forEach(function (b) { b.classList.toggle('is-on', b === x); }); }
    });
    root.addEventListener('change', function (e) {
      var x = e.target;
      if (x.matches('[data-cc-avail]')) { S.avail = x.checked; refresh(false); }
      else if (x.matches('[data-cc-sale]')) { S.sale = x.checked; refresh(false); }
      else if (x.matches('[data-cc-t]')) { toggle(S.t, x.dataset.ccT); refresh(false); }
      else if (x.matches('[data-cc-min]')) { S.min = x.value === '' ? null : +x.value; refresh(true); }
      else if (x.matches('[data-cc-max]')) { S.max = x.value === '' ? null : +x.value; refresh(true); }
      else if (x.matches('[data-cc-sort]')) {
        var u = new URL(location.href); u.searchParams.set('sort_by', x.value); u.searchParams.delete('page'); location.href = u.toString();
      }
    });
    root.addEventListener('input', function (e) {
      if (e.target.matches('[data-cc-rng]')) { S.max = +e.target.value; var mx = $('[data-cc-max]', root); if (mx) mx.value = S.max; apply(); }
    });

    var pages = +root.dataset.pages || 1, next = root.dataset.next;
    function loadNext() {
      if (!next) { build(); apply(); return; }
      var ld = $('[data-cc-load]', root); ld.hidden = false;
      fetch(next).then(function (r) { return r.text(); }).then(function (t) {
        var d = new DOMParser().parseFromString(t, 'text/html');
        var sec = d.querySelector('[data-fg-coll]');
        $$('.fg-cc__it', sec).forEach(function (it) { grid.appendChild(D.importNode(it, true)); });
        next = sec && sec.dataset.next;
        apply(); loadNext();
      }).catch(function () { ld.hidden = true; build(); apply(); });
    }
    build(); apply();
    if (next) { loadNext(); var iv = setInterval(function () { if (!next) { clearInterval(iv); $('[data-cc-load]', root).hidden = true; build(); apply(); } }, 600); }
    $$('[data-cc-cols]', root).forEach(function (b) { if (b.dataset.ccCols === '3') b.classList.add('is-on'); });
  }
  function boot() { $$('[data-fg-coll]').forEach(init); }
  if (D.readyState !== 'loading') boot(); else D.addEventListener('DOMContentLoaded', boot);
})();
